
import Vue from 'vue';
import { Icon } from '@descomplica/vue-components';

export default Vue.extend({
  components: {
    Icon,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    routerName: {
      type: String,
      default: 'home',
    },
    routerPath: {
      type: String,
      default: '',
    },
  },
});
